import { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { ReceiptLongOutlined } from '@mui/icons-material';
import { useConnectLogContext } from '../../context/connectLog';
import { useAuthContext } from '../../context/auth';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { ConfirmDialog } from '../dialogKit';

const Delete = ({ id, name, onDeleted }) => {
  const axiosPrivate = useAxiosPrivate();
  const { dispatch } = useConnectLogContext();
  const { auth } = useAuthContext();
  const [error, setError] = useState(null);
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);

  const handleDelete = async () => {
    if (!auth) {
      setError('You must be logged in');
      return;
    }

    setBusy(true);
    setError(null);
    try {
      await axiosPrivate.delete(`/api/connectLogs/${id}`);

      dispatch({ type: 'DELETE_CONNECTLOG', payload: id });
      onDeleted?.();
      setShow(false);
    } catch (error) {
      console.error('Delete connectLog error:', error);
      setError(error.response?.data?.error || 'Delete failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <Tooltip title="Delete connection log">
        <IconButton
          color="secondary"
          size="small"
          onClick={() => { setError(null); setShow(true); }}
        >
          <DeleteIcon />
        </IconButton>
      </Tooltip>

      <ConfirmDialog
        open={show}
        onClose={() => setShow(false)}
        onConfirm={handleDelete}
        busy={busy}
        error={error}
        title="Delete connection log?"
        message="This log entry is removed from the history."
        item={name}
        itemIcon={ReceiptLongOutlined}
        confirmLabel="Delete log"
      />
    </>
  );
};

export default Delete;
